// Infinite marquee of pill items.
export default function Marquee({ items = [], className = "" }) {
  const list = [...items, ...items];
  return (
    <div className={`relative overflow-hidden ${className}`}>
      <div className="flex w-max marquee-track gap-4">
        {list.map((it, i) => (
          <span key={i} className="whitespace-nowrap rounded-full glass px-5 py-2 text-sm font-medium text-slate-600">
            {it}
          </span>
        ))}
      </div>
    </div>
  );
}
